import moment from "moment/moment";
import { STRING_ACCESSTOKEN_PLATAFORMA } from "./const/string-const";

export const parseJwt = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function onParseJWT(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
};

// export const verifyTokenExpire = (redirect) => {
//   try {
//     const accessToken = localStorage.getItem(STRING_ACCESSTOKEN_PLATAFORMA);
//     if (!accessToken) throw new Error("No access token");
//     const decodedAccessToken = parseJwt(accessToken);
//     const expire = decodedAccessToken.exp * 1000;
//     const now = new Date().getTime();
//     if (now > expire) {
//       redirect();
//     }
//     return expire;
//   } catch (e) {
//     console.error(e);
//     redirect();
//   }
// };

export const isTokenExpire = () => {
  try {
    const accessToken = localStorage.getItem(STRING_ACCESSTOKEN_PLATAFORMA);
    if (!accessToken) throw new Error("No access token");
    const decodedAccessToken = parseJwt(accessToken);
    // console.log('decodedAccessToken');
    // console.log(decodedAccessToken);
    const expire = decodedAccessToken.exp * 1000;
    // console.log('expire');
    // console.log(expire);
    const now = new Date().getTime();
    // console.log('now');
    // console.log(now);
    if (now > expire) {
      return true;
    }
    const utcTime = moment.utc();
    // console.log('utcTime');
    // console.log(utcTime);
    const expiration = moment.utc(decodedAccessToken.fechaExpiracion);
    // console.log('expiration');
    // console.log(expiration);
    if (utcTime.isAfter(expiration)) {
      return true;
    }
    return false;
  } catch (e) {
    console.error(e);
    return true;
  }
};
